export default (degree: number) => {
    if (degree === null) {
        return "n/a"
    } else if (degree < 0) {
        return `(${degree}°)`
    } else {
        return `${degree}°`
    }
}